export function DealershipSettingsCtrl (
  $q, 
  $scope, 
  $state, 
  $stateParams, 
  $window, 
  $translate, 
  confirm, 
  Dealership, 
  messages, 
  sessionObjAPI, 
  streamSearch, 
  workshopAPI, 
  company, 
  dealership
) {

  $scope.company    = company;
  $scope.Dealership = new Dealership(dealership);

  $scope.deactivate = function () {
    $scope.Dealership.deactivate().then(function () {
      $state.go('app.dashboard');

      // use $window's reload to refresh
      // all previously hidden items.
      $window.location.reload();
    }, function (error) {
      messages.error(error);
    });
  }

  $scope.save = function () {
    $scope.Dealership.save().then(function () {
      messages.show($translate.instant('JS_SPACE.MESSAGES.SAVED.DEALERSHIP_SETTINGS'), 'success');
    }, function (error) {
      messages.error(error);
    });
  }

  $scope.viewInternalCustomer = function () {
    $state.go('app.customer', {
        id: $scope.Dealership.internal_customer_id
    });
  }

  $scope.viewProduct = function (key) {
    $state.go('app.product', {
        id: $scope.Dealership[key]
    });
  }

  $stateParams.activated ? messages.show($translate.instant('JS_SPACE.MESSAGES.DEALERSHIP_ACTIVATED'), 'success'): null;
};